import styled from "@emotion/styled";

export const Icon = styled.img`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background-image: url(${({ icon }: { icon: string }) => (icon ? icon : "")});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
`;
